import React from 'react';
import { Grid, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useConditionalLogicStore from '../useConditionalLogicStore';
import { reportStoreError } from '../../../utils/storeErrorReporter';
import ItemCondition from './ItemCondition';
import MentionEditor from '../../TextEditor/MentionEditor';

class ItemStatementCondition extends React.Component {
  // isNumber = (value) => {
  //   const { outputType } = this.props;
  //   let isNumber = (outputType == 'NUMBER' ? !Number.isInteger(Number(value)) : false);
  //   console.log(isNumber);
  //   if (isNumber) {
  //     ConditionalLogicStore.setError(isNumber);
  //   }
  //   return isNumber;
  // }

  state = {
    updateState: false,
  };

  componentDidMount() {
    const { condition } = this.props;
    const { operators } = condition;

    if (operators) {
      operators.map(con => {
        if (con.conditionRandomKey === undefined && con.logic !== 'undefined') {
          con['conditionRandomKey'] = Math.random();
        }
      });
    }
  }

  forceUpdateState = () => {
    let currentState = this.state.updateState;

    this.setState({ updateState: !currentState });
  };

  render() {
    let { positions, placeholders } = (this.props.componentStore || useConditionalLogicStore).getState();
    const { indexStatement, condition, indexLogic, outputType, availablePlaceholders } = this.props;

    const { operators } = condition;

    let elseArray = [];
    let thenArray = [];
    placeholders = placeholders;

    if (
      positions.indexLogic == indexLogic &&
      positions.indexStatement == indexStatement &&
      positions.indexCondition == null &&
      positions.type == 'ELSE'
    ) {
      elseArray = placeholders;
    }
    if (
      positions.indexLogic == indexLogic &&
      positions.indexStatement == indexStatement &&
      positions.indexCondition == null &&
      positions.type == 'THEN'
    ) {
      thenArray = placeholders;
    }

    return (
      <div className={'logic-statement'}>
        {operators && operators.length > 0 ? (
          <Grid
            container
            item
            direction={'column'}
            xs={12}
            className={this.props.classes.conditionFrame}
          >
            {operators &&
              operators.map((con, index) => (
                <ItemCondition
                  classes={this.props.classes}
                  isExpanded={this.props.isExpanded}
                  key={con.conditionRandomKey}
                  indexCondition={index}
                  indexStatement={indexStatement}
                  indexLogic={indexLogic}
                  condition={con}
                  statement={condition}
                  availablePlaceholders={availablePlaceholders}
                  forceUpdateState={this.forceUpdateState}
                  forceUpdateStatement={this.props.forceUpdateState}
                  componentStore={this.props.componentStore}
                />
              ))}
            <Grid item xs={12} className={this.props.classes.spacing}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    (this.props.componentStore || useConditionalLogicStore).getState().addCondition(indexLogic, indexStatement);
                  } catch (err) {
                    reportStoreError('conditional_logic', '', 'addCondition', err);
                  }
                  this.forceUpdateState();
                }}
                sx={{ textTransform: 'none' }}
              >
                Add AND/OR condition
              </Button>
            </Grid>
            <Grid container xs={12} direction={'row'} alignItems={'center'}>
              <Grid
                xs={this.props.isExpanded ? 1 : 12}
                item
                style={{
                  marginBottom: this.props.isExpanded ? '' : '16px',
                }}
              >
                <p className={!this.props.isExpanded && 'm-0'}>Then</p>
              </Grid>
              <Grid xs={this.props.isExpanded ? 10 : 12} item>
                <MentionEditor
                  style={{ width: '100%' }}
                  availablePlaceholders={availablePlaceholders}
                  placeholders={thenArray}
                  text={condition.then.statement.content}
                  placeholder="Insert placeholders and/or text"
                  minHeight={100}
                  onChange={value => {
                    if (value !== condition.then.statement.content) {
                      (this.props.componentStore || useConditionalLogicStore).getState().setThenContent(value, indexLogic, indexStatement, true);
                    }
                  }}
                  onFocus={() => {
                    let positions = {
                      indexLogic,
                      indexStatement,
                      indexCondition: null,
                      type: 'THEN',
                    };
                    (this.props.componentStore || useConditionalLogicStore).getState().setPositions(positions);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <div>
            <Grid item xs={12} className={this.props.classes.spacing}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    (this.props.componentStore || useConditionalLogicStore).getState().addStatement(indexLogic);
                  } catch (err) {
                    reportStoreError('conditional_logic', '', 'addStatement', err);
                  }
                  this.props.forceUpdateState();
                }}
                sx={{ textTransform: 'none' }}
              >
                Add ELSE IF statement
              </Button>
            </Grid>
            <Grid
              container
              direction={'row'}
              alignItems={'center'}
              xs={12}
              className={this.props.classes.conditionFrame}
            >
              <Grid
                xs={this.props.isExpanded ? 1 : 12}
                style={{
                  marginBottom: this.props.isExpanded ? '' : '16px',
                }}
                item
              >
                Else
              </Grid>

              <Grid xs={this.props.isExpanded ? 10 : 12} item>
                <MentionEditor
                  style={{ width: '100%' }}
                  availablePlaceholders={availablePlaceholders}
                  placeholders={elseArray}
                  text={condition.then.statement.content}
                  placeholder="Insert placeholders or/and text"
                  minHeight={100}
                  onChange={value => {
                    (this.props.componentStore || useConditionalLogicStore).getState().setThenContent(value, indexLogic, indexStatement, true);
                  }}
                  onFocus={() => {
                    let positions = {
                      indexLogic,
                      indexStatement,
                      indexCondition: null,
                      type: 'ELSE',
                    };
                    (this.props.componentStore || useConditionalLogicStore).getState().setPositions(positions);
                  }}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export default ItemStatementCondition;
